import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavSubItemComponent } from '../nav-sub-item.component';
import { Router } from '@angular/router';
import { IncompleteSubNavItemViewModel } from './incomplete-sub-nav-item-view-model';

@Component({
  selector: 'app-incomplete-sub-nav-item',
  templateUrl: './incomplete-sub-nav-item.component.html',
  styleUrls: ['./incomplete-sub-nav-item.component.scss', '../nav-sub-item.component.scss'],
  providers: [IncompleteSubNavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IncompleteSubNavItemComponent extends NavSubItemComponent {
  constructor(
    public override viewModel: IncompleteSubNavItemViewModel,
    router: Router
  ) {
    super(viewModel, router);
  }
}
